module.exports = __webpack_public_path__ + "img/unidad-nacional.ba990085.png";